import React from 'react';
import PropTypes from 'prop-types';

const LoadingMini = (props) => {
  const {
    color,
    size
  } = props;

  const boxSize = `${size}px`;

  return (
    <div className="loader">
      <svg
        version="1.1"
        id="loading-mini"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={boxSize}
        height={boxSize}
        viewBox="0 0 50 50"
        xmlSpace="preserve"
      >
        <path
          fill={color}
          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
        >
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  );
};

LoadingMini.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

LoadingMini.defaultProps = {
  color: '#FFF',
  size: 30
};

export default LoadingMini;



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingMini.js